import { DATA_PATHS } from '@lib/constants';

const IntroductionDocumentSection = () => {
  return (
    <section
      className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: 'var(--color-theme-1)' }}
    >
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-6 sm:mb-8">
          <h2
            className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold mb-3 sm:mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            Read My Full Introduction
          </h2>
          <p
            className="text-base sm:text-lg max-w-2xl mx-auto mb-6 sm:mb-8"
            style={{ color: 'var(--color-subtle)' }}
          >
            Dive deeper into my background, achievements, and aspirations with my comprehensive
            introduction document.
          </p>
        </div>

        <div
          className="rounded-lg sm:rounded-xl overflow-hidden"
          style={{
            backgroundColor: 'var(--color-card-bg)',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'var(--color-card-border)',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          {/* PDF Preview */}
          <div className="relative w-full h-96 sm:h-[600px]">
            <iframe
              src={DATA_PATHS.INTRODUCTION}
              className="w-full h-full"
              title="Introduction Document"
              style={{
                border: 'none',
                backgroundColor: 'var(--color-theme-2)',
              }}
            />
          </div>

          {/* Download button */}
          <div className="p-4 sm:p-6 text-center" style={{ backgroundColor: 'var(--color-theme-1)' }}>
            <a
              href={DATA_PATHS.INTRODUCTION}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 font-medium rounded-lg transition-all duration-200 px-5 sm:px-6 py-2.5 sm:py-3 text-base sm:text-lg shadow-card hover:shadow-card-hover"
              style={{
                backgroundColor: 'var(--color-button-primary-bg)',
                color: 'var(--color-button-primary-text)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--color-button-primary-hover)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--color-button-primary-bg)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <svg
                className="w-4 h-4 sm:w-5 sm:h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <span className="hidden sm:inline">Download Full Introduction</span>
              <span className="sm:hidden">Download Introduction</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroductionDocumentSection;
